import { AbstractControl, ValidatorFn } from '@angular/forms';

export function maxValue(max: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        let input = control.value;
      const comma = /,/g;
      const dot = /\./g;
        input = String(input);
        input = input.replace(dot, '');
        input = input.replace(comma, '.');
      const isValid = input > max;
        if (isValid) {
          return {maxValue: {max}};
        } else {
            return null;
        }
    };
}
